<template>
  <div class="mb10">
    <table class="w-100">
      <tr class="bg-kplh-primary text-white">
        <td rowspan="2" class="col-1">NO</td>
        <td rowspan="2" class="col-5">PERSYARATAN</td>
        <td class="col-1">BOBOT</td>
        <td class="col-1">NILAI</td>
        <td rowspan="3" class="col-4">PENJELASAN HASIL PENILAIAN</td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td>{{ totalBobot }}</td>
        <!-- <td>{{ totalNilai }}</td> -->
        <td>{{ nilai }}</td>
      </tr>
      <!-- A -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">A</td>
        <td class="col-5">KEBIJAKAN, KEPEMIMPINAN & KOMITMEN</td>
        <td class="col-1">{{ bobot_a_1 + bobot_a_2 }}</td>
        <td class="col-1">{{ componentAScore }}</td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan Kebijakan perusahaan tentang Keselamatan
          Pertambangan dan Lingkungan Hidup / Health, Safety & Environmental
        </td>
        <td class="col-1">{{ bobot_a_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_a_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_a_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan catatan / bukti komunikasi Kebijakan kepada pekerja baik
          pekerja baru maupun pekerja lama
        </td>
        <td class="col-1">{{ bobot_a_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_a_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_a_2', '') }}
        </td>
      </tr>
      <!-- B -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">B</td>
        <td class="col-5">MANAJEMEN RISIKO</td>
        <td class="col-1">{{ bobot_b_1 + bobot_b_2 + bobot_b_3 + bobot_b_4 }}</td>
        <td class="col-1">{{ componentBScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan prosedur yang mengatur proses manajemen risiko
        </td>
        <td class="col-1">{{ bobot_b_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_b_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_b_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan hasil analisa risiko yang terakhir
        </td>
        <td class="col-1">{{ bobot_b_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_b_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_b_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          "Lampirkan salinan contoh tindak lanjut dari hasil analisa risiko.
          (Contoh: Hasil analisa risiko ditindaklanjuti dengan pembuatan
          prosedur atau dimasukkan dalam program kerja, dll.)"
        </td>
        <td class="col-1">{{ bobot_b_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_b_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_b_3', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">4</td>
        <td class="col-5">
          Lampirkan 2 (dua) contoh salinan Analisa Keselamatan Kerja / JSA
        </td>
        <td class="col-1">{{ bobot_b_4 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_b_4', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_b_4', '') }}
        </td>
      </tr>
      <!-- c -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">C</td>
        <td class="col-5">
          PERATURAN PERUNDANGAN DAN PERSYARATAN LAINNYA (P3L)
        </td>
        <td class="col-1">{{ bobot_c_1 }}</td>
        <td class="col-1">{{ componentCScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur tentang peraturan perundangan dan persyaratan
          lainnya (P3L)?
        </td>
        <td class="col-1">{{ bobot_c_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_c_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_c_1', '') }}
        </td>
      </tr>
      <!-- D -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">D</td>
        <td class="col-5">TUJUAN, SASARAN & PROGRAM KPLH</td>
        <td class="col-1">{{ bobot_d_1 + bobot_d_2 }}</td>
        <td class="col-1">{{ componentDScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan program tahunan KPLH / HSE yang terakhir.
        </td>
        <td class="col-1">{{ bobot_d_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_d_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_d_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan hasil evaluasi pencapaian program tahuan KPLH / HSE tahun
          sebelumnya.
        </td>
        <td class="col-1">{{ bobot_d_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_d_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_d_2', '') }}
        </td>
      </tr>
      <!-- E -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">E</td>
        <td class="col-5">ORGANISASI DAN SUMBER DAYA</td>
        <td class="col-1">{{ bobot_e_1 + bobot_e_2 + bobot_e_3 }}</td>
        <td class="col-1">{{ componentEScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan struktur organisasi yang memiliki tanggung jawab KPLH
        </td>
        <td class="col-1">{{ bobot_e_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_e_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_e_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan daftar Tenaga Teknis Pertambangan / Tenaga Teknik Khusus
          yang bertanggung jawab terhadap Keselamatan Operasi atau Keselamatan
          Sarana, Prasarana, Instalasi & Peralatan
        </td>
        <td class="col-1">{{ bobot_e_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_e_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_e_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan bukti kompetensi dari personil tersebut
        </td>
        <td class="col-1">{{ bobot_e_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_e_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_e_3', '') }}
        </td>
      </tr>
      <!-- F -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">F</td>
        <td class="col-5">KOMPETENSI PEKERJA</td>
        <td class="col-1">{{ bobot_f_1 + bobot_f_2 + bobot_f_3 }}</td>
        <td class="col-1">{{ componentFScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan matriks / peta / kamus kompetensi perusahaan
        </td>
        <td class="col-1">{{ bobot_f_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_f_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_f_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan hasil identifikasi kompetensi pekerja terhadap
          matriks / peta / kamus kompetensi yang terakhir
        </td>
        <td class="col-1">{{ bobot_f_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_f_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_f_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan rencana pelatihan terkait KPLH tahun terakhir
        </td>
        <td class="col-1">{{ bobot_f_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_f_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_f_3', '') }}
        </td>
      </tr>
      <!-- G -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">G</td>
        <td class="col-5">KOMUNIKASI</td>
        <td class="col-1">{{ bobot_g_1 + bobot_g_2 + bobot_g_3 }}</td>
        <td class="col-1">{{ componentGScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan program pertemuan KPLH tahun terakhir
        </td>
        <td class="col-1">{{ bobot_g_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_g_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_g_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan rapat KPLH (mis. Safety talk) yang dilakukan
          diperusahaan (minimal 3)
        </td>
        <td class="col-1">{{ bobot_g_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_g_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_g_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan kehadiran induksi KPLH kepada karyawan (minimal 2)
        </td>
        <td class="col-1">{{ bobot_g_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_g_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_g_3', '') }}
        </td>
      </tr>
      <!-- H -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">H</td>
        <td class="col-5">TANGGUNG JAWAB KPLH</td>
        <td class="col-1">{{ bobot_h_1 }}</td>
        <td class="col-1">{{ componentHScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan 3 salinan deskripsi pekerjaan / job desc karyawan
        </td>
        <td class="col-1">{{ bobot_h_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_h_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_h_1', '') }}
        </td>
      </tr>
      <!-- I -->
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">I</td>
        <td class="col-5">IMPLEMENTASI</td>
        <td class="col-1">{{ bobot_i2_1 + bobot_i2_2 + bobot_i2_3 + bobot_i31_1 + bobot_i31_2 + bobot_i32_1 +
          bobot_i34_1
          + bobot_i34_3 + bobot_i4_1 + bobot_i4_2 + bobot_i4_3 + bobot_i51_1 + bobot_i51_2 + bobot_i52_1 + bobot_i52_2 +
          bobot_i52_3 + bobot_i54_1 + bobot_i54_3 + bobot_i6_1 + bobot_i6_2 + bobot_i7_1 + bobot_i7_2 + bobot_i8_1 +
          bobot_i8_2 + bobot_i8_3 + bobot_i9_1 + bobot_i9_2}}</td>
        <td class="col-1">{{ componentIScore }}</td>
        <td class="col-4"></td>
      </tr>

      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.1</td>
        <td class="col-5">INSPEKSI</td>
        <td class="col-1">{{ bobot_i2_1 + bobot_i2_2 + bobot_i2_3 }}</td>
        <td class="col-1">{{ componentI1Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">Lampirkan prosedur terkait inspeksi.</td>
        <td class="col-1">{{ bobot_i2_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i2_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i2_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan program inspeksi tahun terakhir
        </td>
        <td class="col-1">{{ bobot_i2_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i2_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i2_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan salah satu rekomendasi hasil inspeksi dan bukti
          tindaklanjutnya
        </td>
        <td class="col-1">{{ bobot_i2_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i2_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i2_3', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.2</td>
        <td class="col-5">PENGELOLAAN KESEHATAN KERJA</td>
        <td class="col-1">{{ bobot_i31_1 + bobot_i31_2 + bobot_i32_1 + bobot_i34_1 + bobot_i34_3 }}</td>
        <td class="col-1">{{ componentI2Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="bg-kplh-third">
        <td class="col-1">I.2.1</td>
        <td class="col-5">PEMERIKSAAN KESEHATAN</td>
        <td class="col-1">{{ bobot_i31_1 + bobot_i31_2 }}</td>
        <td class="col-1">{{ componentI21Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan salinan prosedur pengelolaan kesehatan kerja
        </td>
        <td class="col-1">{{ bobot_i31_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i31_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i31_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan hasil pemeriksaan kesehatan awal dan pemeriksaan
          kesehatan berkala untuk satu orang pekerja lapangan
        </td>
        <td class="col-1">{{ bobot_i31_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i31_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i31_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-third">
        <td class="col-1">I.2.2</td>
        <td class="col-5">PENGELOLAAN KELELAHAN</td>
        <td class="col-1">{{ bobot_i32_1 }}</td>
        <td class="col-1">{{ componentI22Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan program terkait pengelolaan kelelahan di tempat kerja tahun
          terakhir
        </td>
        <td class="col-1">{{ bobot_i32_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i32_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i32_1', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-third">
        <td class="col-1">I.2.3</td>
        <td class="col-5">PENGELOLAAN HIGIENE</td>
        <td class="col-1">{{ bobot_i34_1 + bobot_i34_3 }}</td>
        <td class="col-1">{{ componentI23Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">Lampirkan prosedur pengelolaan higiene</td>
        <td class="col-1">{{ bobot_i34_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i34_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i34_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan program pengelolaan higiene yang terakhir
        </td>
        <td class="col-1">{{ bobot_i34_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i34_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i34_3', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.3</td>
        <td class="col-5">PENGELOLAAN LINGKUNGAN KERJA</td>
        <td class="col-1">{{ bobot_i4_1 + bobot_i4_2 + bobot_i4_3 }}</td>
        <td class="col-1">{{ componentI3Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur terkait pengelolaan lingkungan kerja
        </td>
        <td class="col-1">{{ bobot_i4_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i4_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i4_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan salah satu analisa risiko terkait lingkungan kerja
        </td>
        <td class="col-1">{{ bobot_i4_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i4_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i4_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan program pengelolaan lingkungan kerja yang terakhir
        </td>
        <td class="col-1">{{ bobot_i4_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i4_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i4_3', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.4</td>
        <td class="col-5">PENGELOLAAN KESELAMATAN OPERASI</td>
        <td class="col-1">{{ bobot_i51_1 + bobot_i51_2 + bobot_i52_1 + bobot_i52_2 + bobot_i52_3 + bobot_i54_1 +
          bobot_i54_3 }}</td>
        <td class="col-1">{{ componentI4Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="bg-kplh-third">
        <td class="col-1">I.4.1</td>
        <td class="col-5">TENAGA TEKNIS</td>
        <td class="col-1">{{ bobot_i51_1 + bobot_i51_2 }}</td>
        <td class="col-1">{{ componentI41Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan rincian tenaga teknis yang dimiliki perusahaan (jumlah serta
          tugas & tanggung jawabnya).
        </td>
        <td class="col-1">{{ bobot_i51_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i51_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i51_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan bukti kompetensi tenaga teknis (minimal 2).
        </td>
        <td class="col-1">{{ bobot_i51_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i51_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i51_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-third">
        <td class="col-1">I.4.2</td>
        <td class="col-5">SARANA PRASARANA, INSTALASI & PERALATAN</td>
        <td class="col-1">{{ bobot_i52_1 + bobot_i52_2 + bobot_i52_3 }}</td>
        <td class="col-1">{{ componentI42Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan daftar sarana, prasarana, instalasi dan peralatan (SPIP)
          yang dimiliki perusahaan.
        </td>
        <td class="col-1">{{ bobot_i52_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i52_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i52_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan prosedur pemeliharaan untuk setiap jenis SPIP.
        </td>
        <td class="col-1">{{ bobot_i52_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i52_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i52_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          "Lampirkan salinan program pemeliharaan rutin SPIP (minimal untuk 4
          jenis SPIP). Jika program pemeliharaan dilakukan oleh pihak ketiga,
          jelaskan pihak ketiga yang melakukan pemeliharaan rutin SPIP."
        </td>
        <td class="col-1">{{ bobot_i52_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i52_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i52_3', '') }}
        </td>
      </tr>

      <tr class="bg-kplh-third">
        <td class="col-1">I.4.3</td>
        <td class="col-5">KELAYAKAN SPIP</td>
        <td class="col-1">{{ bobot_i54_1 + bobot_i54_3 }}</td>
        <td class="col-1">{{ componentI43Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">Lampirkan prosedur pengujian kelayakan SPIP.</td>
        <td class="col-1">{{ bobot_i54_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i54_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i54_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan pelaksanaan uji kelayakan SPIP (minimal 3 buah).
        </td>
        <td class="col-1">{{ bobot_i54_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i54_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i54_3', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.5</td>
        <td class="col-5">SISTEM IZIN KERJA</td>
        <td class="col-1">{{ bobot_i6_1 + bobot_i6_2 }}</td>
        <td class="col-1">{{ componentI5Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur terkait izin kerja khusus. Jika prosedur tidak ada,
          lampirkan semua jenis formulir izin kerja khusus.
        </td>
        <td class="col-1">{{ bobot_i6_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i6_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i6_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan formulir izin kerja khusus yang pernah dilakukan.
        </td>
        <td class="col-1">{{ bobot_i6_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i6_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i6_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.6</td>
        <td class="col-5">PENGELOLAAN PERLINDUNGAN LINGKUNGAN</td>
        <td class="col-1">{{ bobot_i7_1 + bobot_i7_2 }}</td>
        <td class="col-1">{{ componentI6Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur terkait pengelolaan perlindungan lingkungan hidup.
        </td>
        <td class="col-1">{{ bobot_i7_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i7_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i7_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan dokumen izin lingkungan yang dimiliki perusahaan.
        </td>
        <td class="col-1">{{ bobot_i7_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i7_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i7_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.7</td>
        <td class="col-5">PROSEDUR KERJA</td>
        <td class="col-1">{{ bobot_i8_1 + bobot_i8_2 + bobot_i8_3 }}</td>
        <td class="col-1">{{ componentI7Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan daftar seluruh prosedur pengendalian operasional yang
          dimiliki perusahaan (seluruh prosedur hingga Analisa Kerja Aman / JSA
          dan Instruksi Kerja Aman).
        </td>
        <td class="col-1">{{ bobot_i8_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i8_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i8_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">Lampirkan prosedur pengendalian dokumen.</td>
        <td class="col-1">{{ bobot_i8_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i8_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i8_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan bukti sosialisasi prosedur pengendalian operasional
          kepada karyawan (minimal 3 bukti).
        </td>
        <td class="col-1">{{ bobot_i8_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i8_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i8_3', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub-second">
        <td class="col-1">I.8</td>
        <td class="col-5">ALAT PELINDUNG DIRI</td>
        <td class="col-1">{{ bobot_i9_1 + bobot_i9_2 }}</td>
        <td class="col-1">{{ componentI8Score }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur tentang penggunaan APD di perusahaan.
        </td>
        <td class="col-1">{{ bobot_i9_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i9_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i9_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan daftar distribusi semua jenis APD, baik APD umum
          maupun APD khusus untuk pekerjaan tertentu.
        </td>
        <td class="col-1">{{ bobot_i9_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_i9_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_i9_2', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">J</td>
        <td class="col-5">KEJADIAN, KECELAKAAN & PENYELIDIKAN</td>
        <td class="col-1">{{ bobot_j_1 + bobot_j_2 + bobot_j_3 + bobot_j_4 }}</td>
        <td class="col-1">{{ componentJScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur terkait kecelakaan dan penyelidikan kecelakaan.
        </td>
        <td class="col-1">{{ bobot_j_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_j_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_j_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan hasil penyelidikan kecelakaan (minimal 2).
        </td>
        <td class="col-1">{{ bobot_j_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_j_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_j_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan bukti kompetensi petugas yang melakukan penyelidikan
          kecelakaan
        </td>
        <td class="col-1">{{ bobot_j_3 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_j_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_j_3', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">4</td>
        <td class="col-5">
          Lampirkan salinan bukti sosialisasi hasil penyelidikan kecelakaan
          kepada pekerja.
        </td>
        <td class="col-1">{{ bobot_j_4 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_j_4', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_j_4', '') }}
        </td>
      </tr>
      <tr class="bg-kplh-sub text-white">
        <td class="col-1">K</td>
        <td class="col-5">STATISTIK KPLH</td>
        <td class="col-1">{{ bobot_k_1 + bobot_k_2 }}</td>
        <td class="col-1">{{ componentKScore }}</td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan laporan kinerja KPLH perusahaan yang terakhir.
        </td>
        <td class="col-1">{{ bobot_k_1 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_k_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_k_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">
          Lampirkan salinan penghargaan dalam bidang KPLH yang pernah didapatkan
          perusahaan.
        </td>
        <td class="col-1">{{ bobot_k_2 }}</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_k_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_k_2', '') }}
        </td>
      </tr>
      <!-- <tr class="bg-kplh-sub text-white">
        <td class="col-1">L</td>
        <td class="col-5">AUDIT INTERNAL</td>
        <td class="col-1">6</td>
        <td class="col-1"></td>
        <td class="col-4"></td>
      </tr>
      <tr class="">
        <td class="col-1">1</td>
        <td class="col-5">
          Lampirkan prosedur audit yang dimiliki perusahaan.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_l_1', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_l_1', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">2</td>
        <td class="col-5">Lampirkan program audit tahunan yang terakhir.</td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_l_2', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_l_2', '') }}
        </td>
      </tr>
      <tr class="">
        <td class="col-1">3</td>
        <td class="col-5">
          Lampirkan salinan laporan audit (eksternal / internal) yang terakhir.
        </td>
        <td class="col-1">2</td>
        <td class="col-1">
          {{ penilaian && $get(penilaian, 'value_l_3', '') }}
        </td>
        <td class="col-4">
          {{ penilaian && $get(penilaian, 'note_l_3', '') }}
        </td>
      </tr> -->

      <tr>
        <td colspan="3" class="bg-kplh-sub text-white text-right">
          HASIL PENILAIAN TOTAL UNTUK KATEGORI
          {{ kplh && $get(kplh, 'request.kplh_penilaian.tingkat_resiko', '-') }}
          <br>
          <span class="text-sm">**Nilai kelulusan adalah 75% atau lebih; di bawah itu, tidak memenuhi syarat untuk
            lulus</span>
        </td>
        <td class="text-center">{{ totalResult }} %</td>
        <!-- <td class="text-center">{{ finalScore }} %</td> -->
        <!-- <td class="text-center bg-success">LULUS PRAKUALIFIKASI</td> -->
        <td :class="`text-center ${finalResult && finalResult.indexOf('TIDAK') != -1
          ? 'bg-danger text-white'
          : 'bg-success'
          }`
          ">
          {{ finalResult }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="bg-kplh-sub text-white text-right">
          Catatan
        </td>
        <!-- <td colspan="2" class="text-center">{{ penilaian && $get(penilaian, 'note', '') }}</td> -->
        <td colspan="2" class="text-center">{{ kplh && $get(kplh, 'request.kplh_penilaian.catatan', '-') }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: [
    'kplh',
    'finalResult',
    'totalResult',
    'penilaian',
    'bobot',
    'totalNilai',
  ],
  data() {
    return {
      bobot_a_2: 2,
      bobot_c_1: 2,
      bobot_d_1: 2,
      bobot_d_2: 2,
      bobot_e_2: 2,
      bobot_e_3: 4,
      bobot_f_1: 4,
      bobot_f_2: 2,
      bobot_f_3: 3,
      bobot_g_1: 2,
      bobot_i2_1: 2,
      bobot_i31_1: 2,
      bobot_i31_2: 2,
      bobot_i32_1: 4,
      bobot_i34_1: 1,
      bobot_i34_3: 1,
      bobot_i4_1: 2,
      bobot_i4_2: 2,
      bobot_i4_3: 1,
      bobot_i51_1: 3,
      bobot_i51_2: 3,
      bobot_i52_2: 2,
      bobot_i52_3: 2,
      bobot_i54_1: 2,
      bobot_i54_3: 2,
      bobot_i6_1: 3,
      bobot_i6_2: 3,
      bobot_i7_1: 4,
      bobot_i8_2: 2,
      bobot_i9_1: 3,
      bobot_j_1: 2,
      bobot_j_2: 2,
      bobot_j_3: 2,
      bobot_j_4: 2,
      bobot_k_1: 2,

      bobot_a_1: 2,
      bobot_b_1: 2,
      bobot_b_3: 3,
      bobot_b_4: 3,
      bobot_g_2: 2,
      bobot_g_3: 2,
      bobot_h_1: 4,
      bobot_i2_2: 2,
      bobot_i2_3: 2,
      bobot_i7_2: 2,
      bobot_i8_3: 3,
      bobot_k_2: 2,

      bobot_b_2: 2,
      bobot_e_1: 2,
      bobot_i52_1: 2,
      bobot_i8_1: 4,
      bobot_i9_2: 2,
    };
  },
  computed: {

    componentAScore() {
      let nilai = 0
      let bobot = 4
      let pertanyaan = 2
      this.penilaian.value_a_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_a_1)
      this.penilaian.value_a_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_a_2)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / 2
      return nilai.toFixed(2)
    },
    componentBScore() {
      let nilai = 0
      let bobot = 10
      let pertanyaan = 4
      this.penilaian.value_b_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_b_1)
      this.penilaian.value_b_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_b_2)
      this.penilaian.value_b_3 == 'N/A' ? (bobot -= 3, pertanyaan--) : nilai += Number(this.penilaian.value_b_3)
      this.penilaian.value_b_4 == 'N/A' ? (bobot -= 3, pertanyaan--) : nilai += Number(this.penilaian.value_b_4)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentCScore() {
      let nilai = 0
      let bobot = 2
      let pertanyaan = 1
      this.penilaian.value_c_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_c_1)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentDScore() {
      let nilai = 0
      let bobot = 4
      let pertanyaan = 2
      this.penilaian.value_d_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_d_1)
      this.penilaian.value_d_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_d_2)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentEScore() {
      let nilai = 0
      let bobot = 8
      let pertanyaan = 3
      this.penilaian.value_e_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_e_1)
      this.penilaian.value_e_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_e_2)
      this.penilaian.value_e_3 == 'N/A' ? (bobot -= 4, pertanyaan--) : nilai += Number(this.penilaian.value_e_3)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentFScore() {
      let nilai = 0
      let bobot = 9
      let pertanyaan = 3
      this.penilaian.value_f_1 == 'N/A' ? (bobot -= 4, pertanyaan--) : nilai += Number(this.penilaian.value_f_1)
      this.penilaian.value_f_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_f_2)
      this.penilaian.value_f_3 == 'N/A' ? (bobot -= 3, pertanyaan--) : nilai += Number(this.penilaian.value_f_3)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentGScore() {
      let nilai = 0
      let bobot = 6
      let pertanyaan = 3
      this.penilaian.value_g_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_g_1)
      this.penilaian.value_g_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_g_2)
      this.penilaian.value_g_3 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_g_3)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentHScore() {
      let nilai = 0
      let bobot = 4
      let pertanyaan = 1
      this.penilaian.value_h_1 == 'N/A' ? (bobot -= 4, pertanyaan--) : nilai += Number(this.penilaian.value_h_1)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentIScore() {
      const result = (Number(this.componentI1Score) + Number(this.componentI2Score) + Number(this.componentI3Score) + Number(this.componentI4Score) + Number(this.componentI5Score) + Number(this.componentI6Score) + Number(this.componentI7Score) + Number(this.componentI8Score))
      return result.toFixed(2)
    },
    componentI1Score() {
      let nilai = 0
      let bobot = 6
      let pertanyaan = 3
      this.penilaian.value_i2_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i2_1)
      this.penilaian.value_i2_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i2_2)
      this.penilaian.value_i2_3 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i2_3)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentI2Score() {
      const result = (Number(this.componentI21Score) + Number(this.componentI22Score) + Number(this.componentI23Score))
      return result.toFixed(2)
    },
    componentI21Score() {
      let nilai = 0
      let bobot = 4
      let pertanyaan = 2
      this.penilaian.value_i31_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i31_1)
      this.penilaian.value_i31_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i31_2)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentI22Score() {
      let nilai = 0
      let bobot = 4
      let pertanyaan = 1
      this.penilaian.value_i32_1 == 'N/A' ? (bobot -= 4, pertanyaan--) : nilai += Number(this.penilaian.value_i32_1)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentI23Score() {
      let nilai = 0
      let bobot = 2
      let pertanyaan = 2
      this.penilaian.value_i34_1 == 'N/A' ? (bobot -= 1, pertanyaan--) : nilai += Number(this.penilaian.value_i34_1)
      this.penilaian.value_i34_3 == 'N/A' ? (bobot -= 1, pertanyaan--) : nilai += Number(this.penilaian.value_i34_3)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentI3Score() {
      let nilai = 0
      let bobot = 5
      let pertanyaan = 3
      this.penilaian.value_i4_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i4_1)
      this.penilaian.value_i4_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i4_2)
      this.penilaian.value_i4_3 == 'N/A' ? (bobot -= 1, pertanyaan--) : nilai += Number(this.penilaian.value_i4_3)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentI4Score() {
      const result = (Number(this.componentI41Score) + Number(this.componentI42Score) + Number(this.componentI43Score))
      return result.toFixed(2)
    },
    componentI41Score() {
      let nilai = 0
      let bobot = 6
      let pertanyaan = 2
      this.penilaian.value_i51_1 == 'N/A' ? (bobot -= 3, pertanyaan--) : nilai += Number(this.penilaian.value_i51_1)
      this.penilaian.value_i51_2 == 'N/A' ? (bobot -= 3, pertanyaan--) : nilai += Number(this.penilaian.value_i51_2)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentI42Score() {
      let nilai = 0
      let bobot = 6
      let pertanyaan = 3
      this.penilaian.value_i52_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i52_1)
      this.penilaian.value_i52_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i52_2)
      this.penilaian.value_i52_3 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i52_3)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentI43Score() {
      let nilai = 0
      let bobot = 4
      let pertanyaan = 2
      this.penilaian.value_i54_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i54_1)
      this.penilaian.value_i54_3 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i54_3)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentI5Score() {
      let nilai = 0
      let bobot = 6
      let pertanyaan = 2
      this.penilaian.value_i6_1 == 'N/A' ? (bobot -= 3, pertanyaan--) : nilai += Number(this.penilaian.value_i6_1)
      this.penilaian.value_i6_2 == 'N/A' ? (bobot -= 3, pertanyaan--) : nilai += Number(this.penilaian.value_i6_2)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentI6Score() {
      let nilai = 0
      let bobot = 6
      let pertanyaan = 2
      this.penilaian.value_i7_1 == 'N/A' ? (bobot -= 4, pertanyaan--) : nilai += Number(this.penilaian.value_i7_1)
      this.penilaian.value_i7_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i7_2)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan

      return nilai.toFixed(2)
    },
    componentI7Score() {
      let nilai = 0
      let bobot = 9
      let pertanyaan = 3
      this.penilaian.value_i8_1 == 'N/A' ? (bobot -= 4, pertanyaan--) : nilai += Number(this.penilaian.value_i8_1)
      this.penilaian.value_i8_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i8_2)
      this.penilaian.value_i8_3 == 'N/A' ? (bobot -= 3, pertanyaan--) : nilai += Number(this.penilaian.value_i8_3)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentI8Score() {
      let nilai = 0
      let bobot = 5
      let pertanyaan = 2
      this.penilaian.value_i9_1 == 'N/A' ? (bobot -= 3, pertanyaan--) : nilai += Number(this.penilaian.value_i9_1)
      this.penilaian.value_i9_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_i9_2)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentJScore() {
      let nilai = 0
      let bobot = 8
      let pertanyaan = 4
      this.penilaian.value_j_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_j_1)
      this.penilaian.value_j_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_j_2)
      this.penilaian.value_j_3 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_j_3)
      this.penilaian.value_j_4 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_j_4)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    componentKScore() {
      let nilai = 0
      let bobot = 4
      let pertanyaan = 2
      this.penilaian.value_k_1 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_k_1)
      this.penilaian.value_k_2 == 'N/A' ? (bobot -= 2, pertanyaan--) : nilai += Number(this.penilaian.value_k_2)
      pertanyaan == 0 ? pertanyaan = 1 : pertanyaan
      nilai = ((nilai * bobot) / 3) / pertanyaan
      return nilai.toFixed(2)
    },
    nilai() {
      const nilai = Number(this.componentAScore) + Number(this.componentBScore) + Number(this.componentCScore) + Number(this.componentDScore) + Number(this.componentEScore) + Number(this.componentFScore) + Number(this.componentGScore) + Number(this.componentHScore) + Number(this.componentIScore) + Number(this.componentJScore) + Number(this.componentKScore)


      return nilai.toFixed(2)
    },

    finalScore() {
      const hasil = (Number(this.nilai) / Number(this.totalBobot)) * 100
      return hasil.toFixed(2)
    },

    totalBobot() {
      // Tinggi
      this.penilaian.value_a_2 == 'N/A' ? this.bobot_a_2 = 0 : 0
      this.penilaian.value_c_1 == 'N/A' ? this.bobot_c_1 = 0 : 0
      this.penilaian.value_d_1 == 'N/A' ? this.bobot_d_1 = 0 : 0
      this.penilaian.value_d_2 == 'N/A' ? this.bobot_d_2 = 0 : 0
      this.penilaian.value_e_2 == 'N/A' ? this.bobot_e_2 = 0 : 0
      this.penilaian.value_e_3 == 'N/A' ? this.bobot_e_3 = 0 : 0
      this.penilaian.value_f_1 == 'N/A' ? this.bobot_f_1 = 0 : 0
      this.penilaian.value_f_2 == 'N/A' ? this.bobot_f_2 = 0 : 0
      this.penilaian.value_f_3 == 'N/A' ? this.bobot_f_3 = 0 : 0
      this.penilaian.value_g_1 == 'N/A' ? this.bobot_g_1 = 0 : 0
      this.penilaian.value_i2_1 == 'N/A' ? this.bobot_i2_1 = 0 : 0
      this.penilaian.value_i31_1 == 'N/A' ? this.bobot_i31_1 = 0 : 0
      this.penilaian.value_i31_2 == 'N/A' ? this.bobot_i31_2 = 0 : 0
      this.penilaian.value_i32_1 == 'N/A' ? this.bobot_i32_1 = 0 : 0
      this.penilaian.value_i34_1 == 'N/A' ? this.bobot_i34_1 = 0 : 0
      this.penilaian.value_i34_3 == 'N/A' ? this.bobot_i34_3 = 0 : 0
      this.penilaian.value_i4_1 == 'N/A' ? this.bobot_i4_1 = 0 : 0
      this.penilaian.value_i4_2 == 'N/A' ? this.bobot_i4_2 = 0 : 0
      this.penilaian.value_i4_3 == 'N/A' ? this.bobot_i4_3 = 0 : 0
      this.penilaian.value_i51_1 == 'N/A' ? this.bobot_i51_1 = 0 : 0
      this.penilaian.value_i51_2 == 'N/A' ? this.bobot_i51_2 = 0 : 0
      this.penilaian.value_i52_2 == 'N/A' ? this.bobot_i52_2 = 0 : 0
      this.penilaian.value_i52_3 == 'N/A' ? this.bobot_i52_3 = 0 : 0
      this.penilaian.value_i54_1 == 'N/A' ? this.bobot_i54_1 = 0 : 0
      this.penilaian.value_i54_3 == 'N/A' ? this.bobot_i54_3 = 0 : 0
      this.penilaian.value_i6_1 == 'N/A' ? this.bobot_i6_1 = 0 : 0
      this.penilaian.value_i6_2 == 'N/A' ? this.bobot_i6_2 = 0 : 0
      this.penilaian.value_i7_1 == 'N/A' ? this.bobot_i7_1 = 0 : 0
      this.penilaian.value_i8_2 == 'N/A' ? this.bobot_i8_2 = 0 : 0
      this.penilaian.value_i9_1 == 'N/A' ? this.bobot_i9_1 = 0 : 0
      this.penilaian.value_j_1 == 'N/A' ? this.bobot_j_1 = 0 : 0
      this.penilaian.value_j_2 == 'N/A' ? this.bobot_j_2 = 0 : 0
      this.penilaian.value_j_3 == 'N/A' ? this.bobot_j_3 = 0 : 0
      this.penilaian.value_j_4 == 'N/A' ? this.bobot_j_4 = 0 : 0
      this.penilaian.value_k_1 == 'N/A' ? this.bobot_k_1 = 0 : 0

      // Sedang
      this.penilaian.value_a_1 == 'N/A' ? this.bobot_a_1 = 0 : 0
      this.penilaian.value_b_1 == 'N/A' ? this.bobot_b_1 = 0 : 0
      this.penilaian.value_b_3 == 'N/A' ? this.bobot_b_3 = 0 : 0
      this.penilaian.value_b_4 == 'N/A' ? this.bobot_b_4 = 0 : 0
      this.penilaian.value_g_2 == 'N/A' ? this.bobot_g_2 = 0 : 0
      this.penilaian.value_g_3 == 'N/A' ? this.bobot_g_3 = 0 : 0
      this.penilaian.value_h_1 == 'N/A' ? this.bobot_h_1 = 0 : 0
      this.penilaian.value_i2_2 == 'N/A' ? this.bobot_i2_2 = 0 : 0
      this.penilaian.value_i2_3 == 'N/A' ? this.bobot_i2_3 = 0 : 0
      this.penilaian.value_i7_2 == 'N/A' ? this.bobot_i7_2 = 0 : 0
      this.penilaian.value_i8_3 == 'N/A' ? this.bobot_i8_3 = 0 : 0
      this.penilaian.value_k_2 == 'N/A' ? this.bobot_k_2 = 0 : 0

      // Rendah
      this.penilaian.value_b_2 == 'N/A' ? this.bobot_b_2 = 0 : 0
      this.penilaian.value_e_1 == 'N/A' ? this.bobot_e_1 = 0 : 0
      this.penilaian.value_i52_1 == 'N/A' ? this.bobot_i52_1 = 0 : 0
      this.penilaian.value_i8_1 == 'N/A' ? this.bobot_i8_1 = 0 : 0
      this.penilaian.value_i9_2 == 'N/A' ? this.bobot_i9_2 = 0 : 0

      const total =
        this.bobot_a_2 +
        this.bobot_c_1 +
        this.bobot_d_1 +
        this.bobot_d_2 +
        this.bobot_e_2 +
        this.bobot_e_3 +
        this.bobot_f_1 +
        this.bobot_f_2 +
        this.bobot_f_3 +
        this.bobot_g_1 +
        this.bobot_i2_1 +
        this.bobot_i31_1 +
        this.bobot_i31_2 +
        this.bobot_i32_1 +
        this.bobot_i34_1 +
        this.bobot_i34_3 +
        this.bobot_i4_1 +
        this.bobot_i4_2 +
        this.bobot_i4_3 +
        this.bobot_i51_1 +
        this.bobot_i51_2 +
        this.bobot_i52_2 +
        this.bobot_i52_3 +
        this.bobot_i54_1 +
        this.bobot_i54_3 +
        this.bobot_i6_1 +
        this.bobot_i6_2 +
        this.bobot_i7_1 +
        this.bobot_i8_2 +
        this.bobot_i9_1 +
        this.bobot_j_1 +
        this.bobot_j_2 +
        this.bobot_j_3 +
        this.bobot_j_4 +
        this.bobot_k_1 +
        this.bobot_a_1 +
        this.bobot_b_1 +
        this.bobot_b_3 +
        this.bobot_b_4 +
        this.bobot_g_2 +
        this.bobot_g_3 +
        this.bobot_h_1 +
        this.bobot_i2_2 +
        this.bobot_i2_3 +
        this.bobot_i7_2 +
        this.bobot_i8_3 +
        this.bobot_k_2 +
        this.bobot_b_2 +
        this.bobot_e_1 +
        this.bobot_i52_1 +
        this.bobot_i8_1 +
        this.bobot_i9_2

      return total
    }
  },
  mounted() {
    // do nothing
  }
}
</script>
